import { SegmentPlacement } from "../world/segment";
import { Card, OfferKind } from "./entities";
import type { HandPlan } from "./handPlan";

/** A "pick 1 of N" card offer. Mutable while open. */
export class Offer {
  id = 0;
  kind = OfferKind.OpeningPath;
  cards: Card[] = [];
  pickedIndex = -1;
  /** Valid segment placements for the picked path card, in deterministic order. */
  ghosts: SegmentPlacement[] = [];
  /** In-run pacing decided when the offer opened (a reroll keeps it and plans from it): whether tower, upgrade and road cards are due. */
  towersDue = false;
  upgradeDue = false;
  roadDue = false;
  /** An in-run offer's hand (decided at open; a reroll plans it afresh, handPlan.rerollPlan): its cards by kind and any borrowed kind. */
  plan: HandPlan | null = null;
  /** In an opening road offer (decided at open): a tower card may be borrowed from the opening tower offers still to come. */
  earlyTowerAllowed = false;
  /** A rare's rally offer (M36, sim/rares.ts): tower/upgrade cards only, outside the card pace. */
  rare = false;

  get hasPick(): boolean { return this.pickedIndex >= 0; }
  get pickedCard(): Card { return this.cards[this.pickedIndex]; }

  reset(id: number, kind: OfferKind): void {
    this.id = id;
    this.kind = kind;
    this.cards = [];
    this.ghosts = [];
    this.pickedIndex = -1;
    this.towersDue = false;
    this.upgradeDue = false;
    this.roadDue = false;
    this.plan = null;
    this.earlyTowerAllowed = false;
    this.rare = false;
  }

  clearPick(): void { this.pickedIndex = -1; this.ghosts = []; }
}
